/**
 * マニフェスト登録件数
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/manifest_reports`

const manifest_report = {
  namespaced: true,
  state: {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      start_month: null,
      end_month: null,
    },
  },
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * ユーザー一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param start_month
     * @param end_month
     * @param page
     * @param format
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { start_month, end_month, page, format }) {
      const api_path = format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
      dispatch('saveCondition', { start_month: start_month, end_month: end_month })
      const params = { start_month: state.condition.start_month, end_month: state.condition.end_month, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.ADMIN_MANIFEST_REPORT, { content }) 
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    saveCondition ({ commit, state }, { start_month, end_month}) {
      const _start_month = (start_month !== undefined) ? start_month : state.condition.start_month
      const _end_month = (end_month !== undefined) ? end_month : state.condition.end_month
      const params = { 
        start_month: _start_month,
        end_month: _end_month
      }
      commit(types.ADMIN_MANIFEST_REPORT_CONDITION, { params })
    },
  },   
  mutations: {
    [types.ADMIN_MANIFEST_REPORT] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_MANIFEST_REPORT_CONDITION] (state, { params }) {
      state.condition.start_month = params.start_month,
      state.condition.end_month = params.end_month
    }
  }, 
}

export default manifest_report
